export const REGENERATE_TASKS = {
  siteManagement: "site-management-list-regenerate",
  studyLocations: "site-management-study-regenerate",
  studyRegistry: "study-registry-regenerate",
}

export const EXPORT_GRID_TASKS = {
  usersGrid: "users-grid report-export",
  filesGrid: "files-report-export",
}

export const ASSESSMENT_TASKS = {
  runAllAssessments: "study-assessments-run-all-assessments",
}

export const AUTHORING_TASKS = {
  validation: "authoring-validation",
  prsPreview: "authoring-prs-preview",
}

export const ALL_MAINTENANCE_TASKS = {
  pullFromPrs: "pull-from-prs",
  validate: "all-maintenance-validate",
}

export const PRS_UPLOAD_TASKS = {
  prsProtocolSiteUpload: "prs-protocol-sites-upload",
  studyRegistryPrsProtocolUpload: "study-registry-prs-protocol-sites-upload",
}
